import Message from '@admin/components/message'
import Panel from '@admin/components/panel'
import New from '../../affiliate/new'
import React from 'react'

const Affiliate = () => {

  const message = {
    svg: 'heart_handshake',
    title: 't(Affiliate Program)',
    text: 't(Get paid to refer new customers to Truevail)',
    buttons: [
      { 
        label: 't(Join Affiliate Program)', 
        modal: New
      }
    ]
  }

  return <Message { ...message } />

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Affiliate)',
  component: <Affiliate />
})

export default Panel(null, mapPropsToPanel)
